// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.journal-table > thead > tr.header-row > th {
  font: bold 11px/15px "Roboto";
  letter-spacing: 0.22px;
  color: #FFF;
  top: 0;
  position: sticky;
  background-color: #0b4323;
}

table.journal-table > tbody > tr.data-row > td {
  font: normal 11px/15px "Roboto";
  letter-spacing: 0.22px;
  color: #424242;
}

table.journal-table > tbody > tr.data-row:nth-child(even) {
  background-color: #eaeaea;
}`, "",{"version":3,"sources":["webpack://./src/style/transformer/JournalDialog.scss"],"names":[],"mappings":"AAGA;EACI,6BAAA;EACA,sBAAA;EACA,WAAA;EACA,MAAA;EACA,gBAAA;EACA,yBATiB;AAOrB;;AAKA;EACI,+BAAA;EACA,sBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,yBAlBS;AAgBb","sourcesContent":["$COLOR_PRIMARY_DARK: get('colors.material.primary.dark');\n$COLOR_GREY: get('colors.grey0');\n\ntable.journal-table > thead > tr.header-row > th {\n    font: bold 11px/15px 'Roboto';\n    letter-spacing: 0.22px;\n    color: #FFF;\n    top: 0;\n    position: sticky;\n    background-color: $COLOR_PRIMARY_DARK;\n}\n\ntable.journal-table > tbody > tr.data-row > td {\n    font: normal 11px/15px 'Roboto';\n    letter-spacing: 0.22px;\n    color: #424242;\n}\n\ntable.journal-table > tbody > tr.data-row:nth-child(even) {\n    background-color: $COLOR_GREY;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
